import ValueNode from './ValueNode';

export default class ErrorNode extends ValueNode<string> {

	public constructor (message: string) {
		super(message);
	}

	normalized () {
		return this;
	}

	public toText () {
		return '';
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/ErrorNode.ts